import { useAuth } from "../context/AuthContext";
import { useLocation } from "react-router-dom";
import {  ROUTES } from "../routes";
import LoadingOverlay from "../shared/ui/LoadingOverlay";
import Navbar from "./navbar";

export function Layout({ children }: { children: React.ReactNode }) {
    const location = useLocation();
  const { loading} = useAuth();

  // Routes where navbar should be hidden
  const hideNavbarRoutes = [ROUTES.LOGIN, ROUTES.SUPER_ADMIN];
  const shouldHideNavbar = hideNavbarRoutes.includes(location.pathname as any);

  if (loading) {
    return <LoadingOverlay />;
  }

  return (
    <div className="bg-[#FDFDFD] h-screen flex flex-col overflow-hidden">
      {/* Conditionally render navbar */}
      {!shouldHideNavbar && <Navbar />}

      {/* Main content area */}
      <main className={!shouldHideNavbar ? "pt-4" : ""}>{children}</main>
    </div>
  );
}
